
import {Component, Watch} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {ref, set} from 'firebase/database';
import {db} from '@/firebase';
import PadoMapComponent from '@/components/ParceDomine/PadoMapComponent.vue';
import PadoMJTurnOrderComponent from '@/components/ParceDomine/PadoMJTurnOrderComponent.vue';
import LotdNPCComponent from "@/components/LandOfTheDread/LotdNPCComponent.vue";
import {MJMixin} from '@/mixins/MJMixin';

@Component({
    components: {LotdNPCComponent, PadoMJTurnOrderComponent, PadoMapComponent},
})

export default class LotdMJComponent extends mixins(MJMixin) {
    fake = "0"
    fake_activate = false;

    created(): void {
        if (this.game.characters) {
            this.npcs = Array(Object.values(this.game.characters).filter(char => {
                return char.isNPC;
            }).length);
            for (let i = 0; i < this.npcs.length; i++) {
                this.npcs[i] = false;
            }
        }
        if (this.game.fake) {
            //@ts-ignore
            this.fake = this.game.fake.value.toString();
            //@ts-ignore
            this.fake_activate = this.game.fake.activated;
        }
    }

    @Watch('fake') async onFakeChange(): Promise<void> {
        await set(ref(db, `/jdrs/${this.game.id}/fake/value`), parseInt(this.fake));
    }
    @Watch('fake_activate') async onFakeActivateChange(): Promise<void> {
        await set(ref(db, `/jdrs/${this.game.id}/fake/activated`), this.fake_activate);
    }
}
